export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14379.d4b4c9ce.jpg";